import type { BoggleGameModeDefinition } from '~/boggle/gameModes/types'
import { BOGGLE_CHALLENGE_ALLOWED_BONUS_IDS } from '~/boggle/gameModes/challengeAllowedBonuses'
import { SPRINT_CORE_PRESET } from './preset'
import { SPRINT_CHALLENGE_CORE_DEFINITIONS } from './cores'
import { SprintHowToPlay } from './howToPlay'

export const SPRINT_GAME_MODE: BoggleGameModeDefinition = {
  challenge: {
    allowedBonusIds: BOGGLE_CHALLENGE_ALLOWED_BONUS_IDS,
    buttonLabel: 'Challenge',
    coreDefinitions: SPRINT_CHALLENGE_CORE_DEFINITIONS,
    practiceOverrides: {
      intervalCount: 3,
    },
  },
  color: '#c96760',
  corePreset: SPRINT_CORE_PRESET,
  howToPlay: <SprintHowToPlay />,
  id: 'sprint',
  name: 'Sprint',
  tagline: 'Throw letters together in a hurry.',
}
